import React from "react"
import {
  theme,
  Section,
  List,
  ListItem,
  Container,
  Box,
  Flex,
  Text,
} from "@singita/components"
import { showByTag } from "gatsby-singita-theme/src/common/utils"
import { LocaleLink } from "gatsby-singita-theme/src/components/LocaleLink"
import { useLanguage } from "gatsby-singita-theme/src/context/LanguageContext"
import { useResourceSets } from "gatsby-singita-theme/src/context/ResourceSetContext"

import LinkWrapper from "../components/Link"
import { CONSTANTS } from "../common/constants"

const styles = {
  sectionContainer: {
    bg: "midGrey",
    borderBottomWidth: "3px",
    borderColor: "lightGrey",
    borderStyle: "solid",
    borderWidth: 0,
    gridGap: `${theme.space[4]}px`,
    gridTemplateColumns: [
      "repeat(2, 1fr)",
      "repeat(2, 1fr)",
      "repeat(3, 1fr)",
      "repeat(4, 1fr)",
    ],
    width: "100%",
  },
  sectionItem: {},
}

const LodgeInformationSection = ({ lodge }) => {
  const lang = useLanguage()
  const lodgesRS = useResourceSets("lodges", lang)
  const {
    lodge: { links },
  } = CONSTANTS
  const DownloadLink = ({ fieldKey, variant, children }) => (
    <LinkWrapper
      variant={variant}
      colorScheme={lodge.color}
      isDownload={true}
      to={lodge[fieldKey].file.url}
      sx={{ width: ["auto", "100%"] }}
      label={children}
      external={true}
    />
  )
  const tags = !!lodge.tags ? JSON.parse(lodge.tags.internal.content) : []
  return (
    !!lodge.lodgeInformation && (
      <Container>
        <Section
          id="lodge-information-section"
          headline={lodge.meta.lodgeInfoTitle}
        >
          <List cols={2}>
            {showByTag(lodge.lodgeInformation, "Singita")
              .filter(l => l.displayForLocale)
              .map((info, index) => {
                const iconId = tags[info.contentful_id]
                return (
                  <LocaleLink
                    key={info.id}
                    data-testid={`lodge-information-${index}`}
                    to={`/lodge/${lodge.slug}/information`}
                    state={{
                      isModal: true,
                      anchor: info.id,
                    }}
                  >
                    <Box key={info.id} sx={{ ...styles.sectionItem }}>
                      <ListItem
                        iconRight="chevron-right"
                        iconLeft={theme.icons[iconId]}
                        iconRightSize={12}
                        pb={[4]}
                        mt={[4]}
                        iconLeftColor={lodge.color}
                        isLink={true}
                        hasBorder={true}
                      >
                        <Text size="body" fontWeight="bold">
                          {info.headline}
                        </Text>
                      </ListItem>
                    </Box>
                  </LocaleLink>
                )
              })}
          </List>
          <Flex flexDirection={["column", "row"]} mt={[2, 4]}>
            {lodge.siteplan && (
              <Box mr={[0, 1]} mb={[1, 0]}>
                <DownloadLink variant="primary" fieldKey="siteplan">
                  {lodgesRS.actionBar.siteplan || links.downloads.siteplan}
                </DownloadLink>
              </Box>
            )}
            {lodge.brochure && (
              <Box mr={[0, 1]} mb={[1, 0]}>
                <DownloadLink variant="outline" fieldKey="brochure">
                  {lodgesRS.actionBar.brochure || links.downloads.brochure}
                </DownloadLink>
              </Box>
            )}
            {lodge.activitiesBrochure && (
              <Box mr={[0, 1]} mb={[1, 0]}>
                <DownloadLink variant="outline" fieldKey="activitiesBrochure">
                  {lodgesRS.actionBar.activitiesBrochure ||
                    links.downloads.activitiesBrochure}
                </DownloadLink>
              </Box>
            )}
            {lodge.communityExperiences && (
              <Box>
                <DownloadLink variant="outline" fieldKey="communityExperiences">
                  {lodgesRS.actionBar.communityExperiences ||
                    links.downloads.communityExperiences}
                </DownloadLink>
              </Box>
            )}
          </Flex>
        </Section>
      </Container>
    )
  )
}

export default LodgeInformationSection
